// extracted by mini-css-extract-plugin
export default {"modalCont":"PhoneNumberModal_modalCont__MDS5I","PhoneTitle":"PhoneNumberModal_PhoneTitle__5MJtA","PhoneNum":"PhoneNumberModal_PhoneNum__UyMp4"};